import { EventsByMonth } from "./events-by-month";

export class EventFilter {
  public static readonly LENGTHS: number[] = [5, 10, 20, 25, 40, 42, 50, 100, 200]

  name?: string;
  dateFrom?: number;
  dateTo?: number;
  status?: number;
  length?: number;
  sport?: number;
  selectedMonth?: EventsByMonth;
  organiserId?: number;

  constructor(
  ) {
  }
}

export class EventFilterParams {
  name?: string;
  dateFrom?: number;
  dateTo?: number;
  status?: number;
  length?: number;
  sport?: number;
  selectedMonth?: EventsByMonth;
  organiserId?: number;


  constructor(name?: string, dateFrom?: number, dateTo?: number, status?: number, length?: number, sport?: number, selectedMonth?: EventsByMonth, organiserId?: number) {
    this.name = name;
    this.dateFrom = dateFrom;
    this.dateTo = dateTo;
    this.status = status;
    this.length = length;
    this.sport = sport;
    this.selectedMonth = selectedMonth;
    this.organiserId = organiserId;
  }

  public static finishedEventsParams(): EventFilterParams {
    let today = new Date()
    today.setHours(0, 0, 0, 0)
    return new EventFilterParams(undefined, undefined, today.getTime(), undefined, undefined, undefined, undefined)
  }

  public static eventCalendarParams(): EventFilterParams {
    let today = new Date()
    today.setHours(0, 0, 0, 0)
    return new EventFilterParams(undefined, today.getTime(), undefined, undefined, undefined, undefined, undefined)
  }
}
